import { url } from '@tencent/ppd-base-libs';

const  PAGE_NAME = 'weCoupons';

/**
 * 判断用户是否是直接进入的抢券活动页面
 * @returns
 */
export function isFromWecoupons()  {
  return  url.getUrlParam('page') === PAGE_NAME;
}

/**
 * 抢券页面是否展示底部导航栏
 * @param curRoute 当前路由信息
 * @returns
 */
export function isShowWeCouponsBottomTab(routePath: string) {
  return routePath.includes(PAGE_NAME);
}
